import HtmlParser from "@/components/HtmlParser";
import { Heading, Text } from "@/components/Typography";
import { DrinkWith, DrinkWithListItem } from "@/models/wine";

import s from "./DrinkWith.module.scss";

interface Props {
	data: DrinkWith;
	title?: string;
}

export function DrinkWith({ data, title }: Props) {
	return (
		<section className={s.section}>
			<Heading as="h2" sizeMobile="xl" sizeDesktop="xl" className={s.heading}>
				{title ? title : "Drinken bij..."}
			</Heading>
			<Text className={s.intro}>
				<HtmlParser content={data.introduction} />
			</Text>
			<ul className={s.items}>
				{data?.list?.map((d, index) => (
					<Item key={index} {...d} />
				))}
			</ul>
		</section>
	);
}

function Item({ item }: DrinkWithListItem) {
	return (
		<li className={s.item}>
			<div className={s.itemIconWrapper}>
				<div className={s.itemIcon}></div>
			</div>
			<Heading as="p" sizeMobile="sm" sizeDesktop="sm">
				{item}
			</Heading>
		</li>
	);
}
